import { AIError } from './types';

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const pollinationsText = async (prompt: string, retries = 3): Promise<string> => {
  const systemPrompt = 'You are a professional assistant for Israeli content creators. Follow instructions perfectly.';
  const encodedPrompt = encodeURIComponent(`${systemPrompt}\n\n${prompt}`);

  for (let attempt = 0; attempt <= retries; attempt++) {
    const response = await fetch(`https://text.pollinations.ai/${encodedPrompt}?model=openai`);

    if (response.ok) {
      return await response.text();
    }

    if (response.status === 429 && attempt < retries) {
      await sleep(3000 * (attempt + 1));
      continue;
    }

    throw new AIError('pollinations', `Pollinations error: ${response.statusText || response.status}`, true);
  }

  throw new AIError('pollinations', 'Pollinations error: max retries exceeded', true);
};
